import axios from "axios";
import router from '@/router'

// 兜底处理：如果环境变量未加载，默认使用本地代理路径
const baseURL = process.env.VUE_APP_BASE_API || '/api/home/v1';

// 创建 axios 实例
const instance = axios.create({
    baseURL: baseURL,
    timeout: 10000,
    // 统一设置默认请求头，避免格式问题
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    }
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 防御性判断：如果没有 url，直接返回配置
    if (!config.url) {
      return config;
    }

    // 定义不需要加 token 的接口路径
    const noTokenPaths = [
      '/login',
      '/register',
      '/getCaptcha'
    ];

    // 判断当前请求是否需要排除 token
    const isNoToken = noTokenPaths.some(path => {
      return config.url.includes(path);
    });
     
    // 非排除接口 → 添加 token 到请求头
    if (!isNoToken) {
      const token = localStorage.getItem('token');
      // 只有 token 存在且有效时才设置
      if (token && token !== 'null' && token !== 'undefined') {
        // ✅ 正确写法：直接赋值，不是调用 set 方法
        config.headers['Zmy-openToken'] = token;
      }
    }
    return config;
  },
  (error) => {
    // 捕获请求拦截器的错误，避免请求直接卡死
    console.error('请求拦截器错误：', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
    (res) => {
        // 确保返回数据存在，避免解构报错
        return res.data || res;
    },
    error => {
        // 处理各种错误场景
        console.error('响应拦截器错误：', error);

        // 先判断是否有响应对象，避免读取 undefined 属性报错
        if (error.response) {
            // 处理 token 过期
            if (error.response.status === 401) {
                localStorage.removeItem('token');
                // 避免重复跳转登录页
                if (router && router.currentRoute.path !== '/login') {
                    router.push('/login');
                    // 提示用户，提升体验
                    alert('登录已过期，请重新登录');
                }
            }
        } else {
            // 网络错误/跨域等无响应的情况
            alert('请求失败，请检查网络或接口地址是否正确');
        }
        return Promise.reject(error);
    }
);

export default instance;